import React from "react";
import PropTypes from "prop-types";
import { Modal, Button, Alert } from "react-bootstrap";
import { format } from "date-fns";

const DownloadStatement = React.forwardRef(({ data }, ref) => (
  <div className="page-wrapper" ref={ref}>
    <div className="content">
      <div className="card border-0">
        <div className="card-body ">
          <div className="payslip-month d-flex">
            <div className="slip-logo">
              {/* <ImageWithBasePath src="assets/img/logo-small.png" alt="Logo" /> */}
            </div>
            <div className="month-of-slip">
              <h4>Advance Payment Details</h4>
            </div>
          </div>
          <div className="emp-details d-flex">
            <div className="emp-name-id">
              <h6>
                Emp Name : <span>{data?.employeeName} ({data?.uniqueID})</span>
              </h6>
              <h6>
                Department : <span>{data?.departmentName}</span>
              </h6>
              <h6>
                Designation : <span>{data?.designationName}</span>
              </h6>
            </div>
            <div className="emp-location-info">
              <h6>
                Advance Amount : <span>{data?.advanceAmount}</span>
              </h6>
              <h6>
                Advance Date :{" "}
                <span>{format(new Date(data?.advanceDate), "dd-MM-yyyy")}</span>
              </h6>
              <h6>
                Paid Amount : <span>{data?.paidAmount}</span>
              </h6>
            </div>
          </div>

          <table className="table table-striped table-bordered table-hover table-responsive">
            <thead>
              <tr>
                <th>Installment Date</th>
                <th>Installment Amount</th>
                <th>Paid Amount</th>
                <th>Balance</th>
                <th>Remarks</th>
                <th>In Payslip</th>
              </tr>
            </thead>
            <tbody>
              {data?.advancePaymentDetails?.map((item, index) => (
                <tr key={index}>
                  <td>
                    {format(new Date(item.installmentDate), "dd-MM-yyyy")}
                  </td>
                  <td>{item.installmentAmount}</td>
                  <td>{item.paidAmount}</td>
                  <td>{item.balanceAmount}</td>
                  <td>{item.remarks || "—"}</td>
                  <td>{item.showInPayslip ? "Yes" : "No"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
));

DownloadStatement.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
};

DownloadStatement.displayName = "Download Advance Payment Statement";

export default DownloadStatement;
